var PricingInterceptor = (function () {
    function PricingInterceptor($q, websiteConfiguration) {
        var _this = this;
        this.$q = $q;
        this.websiteConfiguration = websiteConfiguration;
        this.request = function (config) {
            if (config.url.indexOf('marketLocale=') > -1) {
                return config || _this.$q.when(config);
            }
            if ((config.method === 'GET' || config.method === 'OPTIONS') && config.url.indexOf('pricing') > -1) {
                config.url +=
                    (config.url.indexOf('?') > -1 ? '&' : '?') + 'marketLocale=' + _this.websiteConfiguration.marketLocale;
            }
            return config || _this.$q.when(config);
        };
    }
    PricingInterceptor.Factory = function ($q, websiteConfiguration) {
        return new PricingInterceptor($q, websiteConfiguration);
    };
    return PricingInterceptor;
}());
export { PricingInterceptor };
